module.exports = __webpack_public_path__ + "static/media/019-Kissen_ID_9.0d4092a0.mp3";